import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Loading from "../Components/global/Loading";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsersList } from "../redux/actions/contents";
import PageName from "../Components/global/PageName";
import { FaUserShield, FaUserCheck, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

export default function UsersManagement() {
  const dispatch = useDispatch();
  const { usersList, loading: usersLoading } = useSelector(
    (state) => state.content
  );
  const [pageNo] = useState(1);
  const [pageSize] = useState(20);

  useEffect(() => {
    dispatch(getAllUsersList(pageNo, pageSize));
  }, [dispatch, pageNo, pageSize]);

  return (
    <div className="min-h-screen pb-12">
      <PageName
        title="Users Management"
        subTitle="Manage administrative users, telecallers, and system accounts."
      />

      <div className="max-w-7xl mx-auto px-4 mt-6">
        <div className="overflow-x-auto rounded-2xl shadow-sm border border-slate-200 bg-white">
          <table className="min-w-full divide-y divide-slate-200 text-xs">
            <thead className="bg-slate-50 text-slate-600 uppercase tracking-wider font-semibold">
              <tr>
                <th className="px-6 py-4 text-left">#</th>
                <th className="px-6 py-4 text-left">User Name</th>
                <th className="px-6 py-4 text-left">Email Address</th>
                <th className="px-6 py-4 text-left">Mobile Contact</th>
                <th className="px-6 py-4 text-center">User Access Role</th>
                <th className="px-6 py-4 text-center">Registered Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {usersList?.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-12 text-slate-400">
                    No users registered in database.
                  </td>
                </tr>
              ) : (
                usersList?.map((item, index) => (
                  <motion.tr
                    key={item?.id || index}
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.05 }}
                    className="hover:bg-amber-50/40 transition-colors"
                  >
                    <td className="px-6 py-4 font-bold text-slate-400">
                      {(pageNo - 1) * pageSize + (index + 1)}.
                    </td>
                    <td className="px-6 py-4 font-bold text-slate-900 flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-amber-100 text-amber-700 font-bold flex items-center justify-center text-xs">
                        {item.fullName?.[0]?.toUpperCase() || "U"}
                      </div>
                      <span>{item.fullName}</span>
                    </td>
                    <td className="px-6 py-4 text-slate-600">
                      <div className="flex items-center gap-1.5">
                        <FaEnvelope size={11} className="text-slate-400" />
                        <span>{item.email}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-slate-700">
                      <div className="flex items-center gap-1.5">
                        <FaPhoneAlt size={10} className="text-amber-600" />
                        <span>{item.mobileNo || "N/A"}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="inline-flex items-center gap-1 bg-amber-100 text-amber-800 text-[0.68rem] font-bold uppercase px-3 py-1 rounded-full">
                        {item?.userType === "admin" ? (
                          <FaUserShield size={11} className="text-amber-700" />
                        ) : (
                          <FaUserCheck size={11} className="text-amber-700" />
                        )}
                        {item?.userType}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center text-slate-500 font-medium">
                      {item?.createdAt ? new Date(item.createdAt).toLocaleDateString() : "N/A"}
                    </td>
                  </motion.tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {usersLoading && <Loading />}
    </div>
  );
}
